var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSynergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4173 20.4851L24.4174 20.4853C24.5764 20.8132 24.6798 21.1545 24.7894 21.5163C24.8389 21.6796 24.8896 21.847 24.9473 22.0193C24.8667 24.2962 22.5644 25.661 20.5927 24.5612L20.5926 24.5611C18.5039 23.3976 16.2943 22.7337 13.9007 22.74C11.5352 22.7463 9.34694 23.3974 7.28173 24.5489C5.43287 25.5798 3.31535 24.52 3.06768 22.4305L3.06767 22.4304C3.00221 21.8798 3.13138 21.2164 3.37972 20.6988L3.37984 20.6986C5.59792 16.0626 7.85641 11.4457 10.115 6.82873C10.2369 6.57949 10.3588 6.33025 10.4808 6.081L10.4809 6.08077C10.8418 5.34097 11.311 4.78185 11.8807 4.40601C12.4496 4.03079 13.1321 3.82926 13.9356 3.8249L13.936 3.8249C14.7583 3.81909 15.4471 4.03011 16.0191 4.41901C16.593 4.80918 17.0629 5.38769 17.4296 6.13628L17.4296 6.13633C19.7708 10.9131 22.1 15.696 24.4173 20.4851ZM18.0966 18.135H18.3466V17.885V15.0842V14.8342H18.0966H9.90034H9.65034V15.0842V17.885V18.135H9.90034H12.3834V20.6857V20.9357H12.6334H15.3635H15.6135V20.6857V18.135H18.0966ZM6.73116 4.94172C6.73116 5.99239 5.90155 6.83363 4.89097 6.83363C3.88039 6.83363 3.05078 5.99239 3.05078 4.94172C3.05078 3.89105 3.88039 3.0498 4.89097 3.0498C5.90155 3.0498 6.73116 3.89105 6.73116 4.94172ZM24.9508 4.94172C24.9508 5.99239 24.1212 6.83363 23.1106 6.83363C22.1 6.83363 21.2704 5.99239 21.2704 4.94172C21.2704 3.89105 22.1 3.0498 23.1106 3.0498C24.1212 3.0498 24.9508 3.89105 24.9508 4.94172Z",
    fill: "#FFA800",
    stroke: "url(#paint0_linear_8978_8048)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8978_8048",
    x1: 14.0008,
    y1: 2.7998,
    x2: 14.0008,
    y2: 25.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynergy);
export default __webpack_public_path__ + "static/media/synergy.ad6da1895160ea18f9b757f1aa5ffb49.svg";
export { ForwardRef as ReactComponent };